var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMenuStaking(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_777_623)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M8.61072 7.5689L10.0816 2.66723C8.90405 2.31473 7.59488 2.26723 6.23488 2.66723C3.85238 3.36807 2.02655 5.41307 1.60322 7.86057C0.805718 12.4706 4.74739 16.4131 9.35739 15.6147C11.8041 15.1914 13.8499 13.3656 14.5507 10.9831C14.9507 9.62307 14.9032 8.31307 14.5507 7.1364L9.64905 8.60723C9.01238 8.79723 8.41989 8.20473 8.61072 7.5689Z",
    fill: "#5D6588"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.3149 6.94L16.2165 5.46917C15.5749 3.32833 13.8882 1.64167 11.7474 1L10.2765 5.90167C10.0865 6.53833 10.679 7.13083 11.3149 6.94Z",
    fill: "#5D6588"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_777_623"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuStaking);
export default __webpack_public_path__ + "static/media/menu-staking.82ca464749dd4e81ed9f589744f5c470.svg";
export { ForwardRef as ReactComponent };